<template>
  <div id="app">

    <div class="bg-white navbar-light sticky-top" data-sticky="top">
      <div class="container">
        <div class="row py-2">
          <div class="col">
          <a class="navbar-brand" href="#">
            <h2 class="font-weight-lighter" style="color: #4A4A4A; font-size: 24px;">Tip the Artist</h2>
          </a>
          </div>
          <div class="col">
          <a class="navbar-brand float-right" href="#">
            <img alt="Trackd Music" height="27" src="./assets/logo.png" />
          </a>
          </div>
          
          <!--end nav collapse-->
        </div>
      </div>
      <!--end of container-->
    </div>

    <router-view :key="$route.fullPath" >

        <a href="#">
          <img alt="Trackd Music" height="27" src="./assets/logo.png" />
        </a>

    </router-view>

    <!--
    <footer class="footer-short">
      <div class="container">
        <hr>
        
        <div class="col-auto p-0 text-center">

          <a class="text-muted font-weight-light text-center text-small mb-4" href="https://www.songsstarthere.org/privacy-policy-terms" target="_blank"><small>Privacy & Terms</small></a>
              
        </div>
          
        <div class="row mb-3">
          <div class="col text-center">
            <small class="mb-3">{{ new Date().getFullYear() }} Songs Start Here &copy; All Rights Reserved</small>
          </div>
          
        </div>
        
      </div>

    </footer>
    -->
    
    <b-modal id="modal-center" class="bg-transparent" :hide-header="true" body-class="bg-transparent" :hide-footer="true" :visible="loading" centered>
      
      <template v-slot:default>
        <img alt="Trackd Music" src="./assets/img/custom/trackd-loading.gif" height="60" style="z-index: 4000; opacity: 1;" class=" d-block mx-auto my-5" />
      </template>
      
    </b-modal>

  </div>

</template>

<script>

  export default {
    name: 'app',
    computed: {
      loading() {
        return false
      },
      auth() {
        return this.$store.getters.isAuthenticated
      },
    },
    methods: {
      logoutUser () {
        this.$store.dispatch('logout');
      }
    },
    created() {
      //this.$store.dispatch('autoLogin')
    }
  }
</script>


<style lang="scss">
  // Import custom SASS variable overrides, or alternatively
  // define your variable overrides here instead
  @import 'assets/custom.scss';

  // Import Bootstrap and BootstrapVue source SCSS files
  @import '~bootstrap/scss/bootstrap.scss';
  @import '~bootstrap-vue/src/index.scss';

  // General style overrides and custom classes
  body {
    margin: 0;
  }
</style>



<style lang="css" scoped>
.modal-content {
  opacity: 0;
}

html {
  position: relative;
  min-height: 100%;
}
body {
  /* Margin bottom by footer height */
  margin-bottom: 100px;
  color: #555555;
}
.footer-short {
  position: absolute;
  bottom: 0;
  width: 100%;
  /* Set the fixed height of the footer here */
  height: 100px;

}

</style>
